export const RESET = 'EXSBPRICETYPE_LIST_RESET'
export const SET_ITEMS = 'EXSBPRICETYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBPRICETYPE_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBPRICETYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBPRICETYPE_LIST_TOGGLE_LOADING'
